export default __webpack_public_path__ + "db17afa8ae6eb75ef939925fc9a76962.png";